import { useCallback, useState } from "react";

import {
  OTP_EMAIL_STORAGE_KEY,
  clearOtpStorage,
  setOtpEmailStorage,
  setOtpStateHandleStorage,
} from "@app/utils/otpStorageKeys";
import type { OtpTransaction } from "@app/utils/otpFlow";

const getStoredOtpEmail = () => {
  try {
    return sessionStorage.getItem(OTP_EMAIL_STORAGE_KEY) ?? "";
  } catch {
    return "";
  }
};

export const useOtpState = () => {
  const [isOtpRequestPending, setIsOtpRequestPending] = useState(false);
  const [isOtpVerifyPending, setIsOtpVerifyPending] = useState(false);
  const [otpErrorMessage, setOtpErrorMessage] = useState<string | undefined>();
  const [otpTransaction, setOtpTransaction] = useState<OtpTransaction | null>(
    null
  );
  const [otpResendKey, setOtpResendKey] = useState(0);
  const [otpEmail, setOtpEmail] = useState(getStoredOtpEmail);

  const storeOtpEmail = useCallback((email: string) => {
    setOtpEmail(email);
    setOtpEmailStorage(email);
  }, []);

  const storeOtpStateHandle = useCallback((stateHandle?: string) => {
    if (stateHandle) {
      setOtpStateHandleStorage(stateHandle);
    }
  }, []);

  const clearOtpState = useCallback(() => {
    clearOtpStorage();
    setOtpEmail("");
    setOtpTransaction(null);
    setOtpErrorMessage(undefined);
  }, []);

  const bumpOtpResendKey = useCallback(() => {
    setOtpResendKey(Date.now());
  }, []);

  const clearOtpError = useCallback(() => {
    setOtpErrorMessage(undefined);
  }, []);

  return {
    isOtpRequestPending,
    setIsOtpRequestPending,
    isOtpVerifyPending,
    setIsOtpVerifyPending,
    otpErrorMessage,
    setOtpErrorMessage,
    otpTransaction,
    setOtpTransaction,
    otpResendKey,
    bumpOtpResendKey,
    otpEmail,
    storeOtpEmail,
    storeOtpStateHandle,
    clearOtpState,
    clearOtpError,
  };
};

export default useOtpState;
